import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadService } from '../services/upload.service';
import * as CryptoJS from 'crypto-js';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MetricsService } from '../services/metrics.service';

interface ICountry {
  Country: string;
}
interface ILanguage {
  languages: string;
}

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {
  application: FormGroup;
  nativeLanguageOptions: string[];
  otherLanguageOptions: ILanguage[];
  fluentLangOptions: ILanguage[];
  countryResidentOptions: ICountry[];
  ageOfEnglishOptions: string[];

  nativeSelected: string;
  fluentLangSelected: string;
  otherSelected: string;
  ageSelected: string;
  nationalitySelected: string;
  countryResidentSelected: string;

  otherLanguage: boolean;
  otherSpoken: boolean;
  otherNationality: boolean;
  otherFluentLanguage: boolean;

  totalRecording;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private upload: UploadService,
    private http: HttpClient, 
    private metric: MetricsService,
    private fb: FormBuilder
  ) {

  }

  ngOnInit(): void {
    this.otherLanguage = false;
    this.otherSpoken = false;
    this.otherNationality = false;
    this.otherFluentLanguage = false;

    this.application = this.fb.group({
      nationality: ['', Validators.required],
      countryResidence: ['', Validators.required],
      nativeLanguage: ['', Validators.required],
      fluentLanguage: ['', Validators.required],
      otherLanguages: [''],
      ageOfEnglish: ['', Validators.required],
      otherNativeInput: [''],
      otherSpokenInput: [''],
      otherNationalityInput: [''],
      otherFluentLanguageInput: [''],
      sentence: [''],
      filename: [''],
    });

    //total recordings
    this.metric.getTotalRecording().subscribe((recordings: any) => {
      this.totalRecording = recordings[0].count;
    });

    this.nativeLanguageOptions = [
      'Hausa',
      'Yoruba',
      'Igbo',
      'Fulfulde',
      'Efik-Ibibio',
      'Kanuri',
      'Tiv',
      'Edo',
      'Igala',
      'Nupe',
      'Izon',
      'Others',
    ];

    this.getLanguages().subscribe((data) => {
      this.otherLanguageOptions = data.filter(
        (lang) => lang.languages !== 'English'
      );
      this.fluentLangOptions = data.filter(
        (lang) => lang.languages !== 'English'
      );
    });

    this.getCountry().subscribe((data) => {
      this.countryResidentOptions = data;
    });

    this.ageOfEnglishOptions = ['< 4', '4 - 12', '12 - 20', '20 - 30', '> 30'];

    

    //validation for other fluent language
    this.application.get('fluentLanguage').valueChanges.subscribe((value) => {
      const otherFluentLang = this.application.get('otherFluentLanguageInput');
      if (value === 'Others') {
        otherFluentLang.setValidators(Validators.required);
      } else {
        otherFluentLang.clearValidators();
      }
      otherFluentLang.updateValueAndValidity();
    });

    //validation for other cnationality
    this.application.get('nationality').valueChanges.subscribe((value) => {
      const otherNationality = this.application.get('otherNationalityInput');
      if (value === 'Others') {
        otherNationality.setValidators(Validators.required);
      } else {
        otherNationality.clearValidators();
      }
      otherNationality.updateValueAndValidity();
    });
  }

  goToVoiceRecorder(): void {
    if (this.application.value.nativeLanguage === 'Others') {
      this.application.value.nativeLanguage = this.application.value.otherNativeInput;
    }
    if (this.application.value.nationality === 'Others') {
      this.application.value.nationality = this.application.value.otherNationalityInput;
    }
    if (this.application.value.otherLanguages.includes('Others')) {
      this.application.value.otherLanguages.push(
        this.application.value.otherSpokenInput
      );
    }
    if (this.application.value.fluentLanguage === 'Others') {
      this.application.value.fluentLanguage = this.application.value.otherFluentLanguageInput;
    }

    //save user's input in session
    const userID = CryptoJS.AES.encrypt(
      JSON.stringify(this.application.getRawValue()),
      'secret key 123'
    ).toString();

    interface objectType {
      form?: any;
      userID?: string;
    }

    let obj: objectType = {};
    obj.form = this.application.getRawValue();
    obj.userID = userID;

    sessionStorage.setItem('form', JSON.stringify(obj));

    if (this.application.valid) {
      this.router.navigate(['record']);
      // this.upload.details = this.application.getRawValue();
      this.upload.details = JSON.parse(sessionStorage.form);
    } else {
      this.snackBar.open('Please fill all the fields');
    }
  }

  getLanguages(): Observable<ILanguage[]> {
    return this.http.get('assets/World_lang.json') as Observable<ILanguage[]>;
  }

  getCountry(): Observable<ICountry[]> {
    return this.http.get('assets/Countries.json') as Observable<ICountry[]>;
  }

  onChangeOtherLang() {
    if (this.nativeSelected === 'Others') {
      this.otherLanguage = true;
    } else {
      this.otherLanguage = false;
    }
  }
  onChangeSpokenLang() {
    if (this.otherSelected.includes('Others')) {
      this.otherSpoken = true;
    } else {
      this.otherSpoken = false;
    }
  }

  onChangeNationality() {
    if (this.nationalitySelected === 'Others') {
      this.otherNationality = true;
    } else {
      this.otherNationality = false;
    }
  }

  onChangeFluentLanguage() {
    if (this.fluentLangSelected === 'Others') {
      this.otherFluentLanguage = true;
    } else {
      this.otherFluentLanguage = false;
    }
  }
}
